import { AnyAction } from "redux";

import { ApiService } from "pwapi";

import { GET_BARCODE_BADGES_SUCCESS } from "app/actions/userActions";

type BarcodeBadgeState = Awaited<
  ReturnType<typeof ApiService.listQrAuthTokens>
>;

export const barcodeBadgeReducer = (
  state: BarcodeBadgeState = { count: 0, results: [] },
  action: AnyAction
): BarcodeBadgeState => {
  switch (action.type) {
    case GET_BARCODE_BADGES_SUCCESS:
      return action.payload.response;
    default:
      return state;
  }
};
